import React, { useEffect, useState, useRef } from 'react'
import classes from './NavBar.module.css'
import { ImMenu } from 'react-icons/im'
import { VscClose } from 'react-icons/vsc'
import { Link } from 'react-scroll'

const MobileNavigation = () => {

    let useClickOutside = (handler) => {
        let menuRef = useRef();

        useEffect(() => {
            let clickOutsideHandler = (event) => {
                if (!menuRef.current.contains(event.target)) {
                    handler();
                }
            };

            document.addEventListener("mousedown", clickOutsideHandler);

            return () => {
                document.removeEventListener("mousedown", clickOutsideHandler);
            };
        });

        return menuRef;
    };

    let menuRef = useClickOutside(() => {
        setOpen(false);
    });

    const [open, setOpen] = useState(false)

    const hamburgerIcon = <ImMenu className={classes.Hamburger}
        size='40px' color='white'
        onClick={() => setOpen(!open)} />

    const closeIcon = <VscClose className={classes.Hamburger}
        size='40px' color='white'
        onClick={() => setOpen(!open)} />

    return (
        <nav ref={menuRef} className={classes.MobileNavigation} >
            {open ? closeIcon : hamburgerIcon}
            {open && <ul >
                <li  >
                    <Link onClick={() => setOpen(false)} to="home" smooth="true" duration={550}  >
                        <a href='/#home'>Home</a>
                    </Link>
                </li>
                <li>
                    <Link onClick={() => setOpen(false)} to="about-me" smooth="true" offset={-85} duration={550} >
                        <a href='/#about'>Biography</a>
                    </Link>

                </li>
                <li>
                    <Link onClick={() => setOpen(false)} to="experience" smooth="true" offset={-50} duration={550}>
                        <a href='/#experience'>Work Experience</a>
                    </Link>
                </li>
                <li>
                    <Link onClick={() => setOpen(false)} to="projects" smooth="true">
                        <a href='/#projects'>Projects</a>
                    </Link>
                </li>


            </ul>}
        </nav>
    )
}

export default MobileNavigation